import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import { getLocalValue, LoacalVariables } from "../../commonFunctions/CommonFunctions";

interface WarningModalProps {
    open: boolean;
    handleLoginAgain: () => void;
    handleModalClose: () => void;
}

const WarningModal = ({
    open,
    handleLoginAgain,
    handleModalClose,
}: WarningModalProps) => {
    const userType = getLocalValue(LoacalVariables.UserType);

    let message = userType === 'district' ? 'Please contact the Super Admin to continue!' : 'Please contact the Super Admin Or District to continue!'
    return (
        <Dialog open={open} onClose={handleModalClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Typography variant="h6" color="error" fontWeight={600}>
                    You’re account has been Deactivated.
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary">
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleLoginAgain} variant="contained" color="error">
                    Logout
                </Button>
                <Button onClick={handleModalClose} color="inherit" variant="outlined">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WarningModal;
